import React from 'react';
import './Footer.scss';
import text from 'platform/constants/text.js';

function Footer() {

    return <div className="footer">
        {text.copyrightFooter && <div className="copyright">
            {text.copyrightFooter.replace('{currentYear}', "" + new Date().getFullYear())}
        </div>}
    </div>;
}

export default Footer;